<template>
  <b-col cols="12">
    <p class="menu--visnet__name">
      {{ visnetHub.name || visnetHub.externalVisnetHubId }}
    </p>
    <p>
      {{ visnetHub.substation.name || visnetHub.substation.code }}
    </p>
    <b-button variant="rounded" @click="changeView()">
      Main View
      <Icon name="visnetbub-main" />
    </b-button>
  </b-col>
</template>
<script>
export default {
  name: 'VisnetHubAttributes',
  props: { visnetHub: Object },
  methods: {
    changeView() {
      this.$store.dispatch('substationVisnetHub/changeChartView', {
        name: 'visnetHubDefaultCharts'
      });
      this.$router.push({
        name: 'ElectricalComponent'
      });
    }
  }
};
</script>
